import React, { useEffect } from "react";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import Spinner from "../../components/layout/Spinner";
import {
  inputFields,
  PAGE_TITLE,
  PAGE_SINGLE_TITLE,
  LINK_URL,
  SIDEBAR_OPTIONS,
} from "../../shared/enums/packagetreatments_enum";
import SingleView from "../../components/common/SingleView";
import { useSinglePackagetreatment } from "../../shared/hooks/UsePackagetreatment";
const ViewPackagetreatment = ({ match }) => {
  const [data] = useSinglePackagetreatment(match.params.id);
  const { packagetreatment_loading, packagetreatment } = data;
  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title={PAGE_SINGLE_TITLE}
          mainLinkTitle={PAGE_TITLE}
          mainLinkUrl={LINK_URL}
          activeLink="View"
        />
        {!packagetreatment_loading ? (
          packagetreatment && (
            <SingleView
              data={packagetreatment}
              inputFields={inputFields}
              label={PAGE_SINGLE_TITLE}
              link={LINK_URL}
              id={packagetreatment._id}
              SIDEBAR_OPTIONS={SIDEBAR_OPTIONS}
            />
          )
        ) : (
          <div>
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewPackagetreatment;
